// src/pages/AdminTestJobs.tsx
import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const AdminTestJobs: React.FC = () => {
    const { isAdmin } = useAuth();
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState<any>(null);
    const [error, setError] = useState('');

    if (!isAdmin) {
        return <div style={{ padding: '40px', textAlign: 'center' }}>
            <h2>Acesso negado</h2>
            <p>Apenas administradores podem acessar esta página</p>
        </div>;
    }

    const handleTest = async () => {
        setLoading(true);
        setError('');
        setResult(null);

        try {
            const token = localStorage.getItem('accessToken');
            const response = await fetch('/api/admin/test-subscription-jobs', {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            const data = await response.json();

            if (response.ok) {
                setResult(data);
            } else {
                setError(data.message || 'Erro ao testar jobs');
            }
        } catch (err) {
            setError('Erro ao conectar com o servidor');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
            <h1>🧪 Testar Jobs de Assinatura</h1>

            <button
                onClick={handleTest}
                disabled={loading}
                style={{
                    padding: '12px 24px',
                    background: '#2F7130',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    fontSize: '16px',
                    fontWeight: '600',
                    marginTop: '20px'
                }}
            >
                {loading ? 'Testando...' : 'Executar Teste'}
            </button>

            {error && (
                <div style={{
                    marginTop: '20px',
                    padding: '16px',
                    background: '#FEE2E2',
                    borderRadius: '8px',
                    color: '#DC2626'
                }}>
                    ❌ {error}
                </div>
            )}

            {result && (
                <div style={{
                    marginTop: '20px',
                    padding: '20px',
                    background: '#F5F7F5',
                    borderRadius: '8px'
                }}>
                    <h3>✅ Resultado:</h3>
                    <pre style={{
                        background: 'white',
                        padding: '16px',
                        borderRadius: '8px',
                        overflow: 'auto'
                    }}>
                        {JSON.stringify(result, null, 2)}
                    </pre>
                </div>
            )}
        </div>
    );
};

export default AdminTestJobs;